import './fonts.css';

const baseVars = {
  colors: {
    main: '#4A56E2',

    mainText: '#000000',
    secondText: '#FFFFFF',
    thirdText: '#4A56E2',
    fourthText: '#BDBDBD',
    incomeText: '#24CCA7' /*доходи*/,
    expensesText: '#FF6596' /*витрати*/,

    firstBtnBg: '#24CCA7',
    secondBtnBg: '#FF6596',

    bg: 'rgba(255, 255, 255, 0.4)',
    bgModal: 'rgba(0, 0, 0, 0.25)',
    secondBg: '#E7EAF2',

    icon: '#6E78E8',
    iconFocus: '#4A56E2',
  },

  fonts: {
    main: 'Circe',
    second: 'Poppins',
  },

  sizeScreen: {
    desktop: '1280px',
    tablet: '768px',
    mobile: '320px',
  },
};

export default baseVars;
